module.exports = __webpack_public_path__ + "img/signs10.a6e2531d.jpg";